import React, { ReactNode } from "react";
import { connect } from "react-redux";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import cn from "classnames";
import { Link } from "react-router-dom";

import configService from "@app/config/ConfigService";
import { fetchTokenHandoffCode } from "@app/store/app/actions";
import authService from "@app/store/auth/AuthService";
import { getLegacyAppUrl } from "@app/util/appUrl";
import { navigateToLegacyApp } from "@app/util/openLegacyApp";

import styles from "./MenuItemTitle.module.scss";

interface Props {
  active?: boolean;
  children?: ReactNode;
  hasSubmenu?: boolean;
  icon?: IconProp;
  itemName: string;
  legacyPath?: string;
  onClick?: () => void;
  path?: string;
  tooltip?: ReactNode;
}

const MenuItemTitle = ({
  active,
  children,
  hasSubmenu,
  icon,
  itemName,
  legacyPath,
  onClick,
  onFetchTokenHandoffCode,
  path,
  tooltip,
  ...props
}: Props & typeof mapDispatchToProps) => {
  const baseOldAppUrl = configService.getBaseOldAppUrl();
  const token = authService.getToken();

  const dataProps = Object.keys(props ?? {})
    .filter((key) => key.startsWith("data-"))
    .reduce(
      (result, key) => ({ ...result, [key]: ((props ?? {}) as Record<string, string>)[key] }),
      {}
    );

  return (
    <Tooltip title={tooltip}>
      <span
        className={cn(styles.container, { [styles.active]: active })}
        data-navbar-item={itemName}
        onClick={onClick}
        {...dataProps}
      >
        {legacyPath ? (
          <a
            className={styles.link}
            href={getLegacyAppUrl(baseOldAppUrl, undefined, legacyPath)}
            onClick={(event) => {
              event.preventDefault();
              navigateToLegacyApp(onFetchTokenHandoffCode, baseOldAppUrl, token, legacyPath);
            }}
          >
            {icon ? <FontAwesomeIcon className={styles.icon} icon={icon} /> : null}
            {children && <span>{children}</span>}{" "}
          </a>
        ) : null}
        {path ? (
          <Link className={styles.link} to={path}>
            {icon ? <FontAwesomeIcon className={styles.icon} icon={icon} /> : null}
            {children && <span>{children}</span>}{" "}
          </Link>
        ) : null}
        {!path && !legacyPath ? (
          <span>
            {icon ? <FontAwesomeIcon className={styles.icon} icon={icon} /> : null}
            {children && <span>{children}</span>}
          </span>
        ) : null}
        {hasSubmenu ? (
          <span className={styles.chevron}>
            <FontAwesomeIcon icon={faChevronDown} />
          </span>
        ) : null}
      </span>
    </Tooltip>
  );
};

const mapDispatchToProps = {
  onFetchTokenHandoffCode: fetchTokenHandoffCode,
};

export default connect(null, mapDispatchToProps)(MenuItemTitle);
